import { Routes } from '@angular/router';
import { environment } from '../environments/environment';
import { LanguageGuard } from './guards/language-guard';
import { NotFoundComponent } from './features/not-found-component/not-found-component';
import { TermsComponent } from './features/layout/terms-component/terms-component';
import { HomeComponent } from './features/layout/home-component/home-component';
import { CartComponent } from './features/cart-component/cart-component';
import { CheckoutComponent } from './features/checkout-component/checkout-component';
import { Support } from './features/pages/support/support';
import { Welcome } from './features/pages/welcome/welcome';
import { ConfirmMailCallback } from './account/confirm-mail-callback/confirm-mail-callback';
import { PaymentComponent } from './features/payment-component/payment-component';
import { TierFeaturesComponent } from './features/layout/tier-features-component/tier-features-component';
import { Banner2Component } from './features/layout/banner2-component/banner2-component';
import { FAQComponent } from './features/layout/faqcomponent/faqcomponent';
import { PrivacyComponent } from './features/layout/privacy-component/privacy-component';
import { PaymentPolicyComponent } from './features/layout/payment-policy-component/payment-policy-component';
import { BlogComponent } from './features/blog-component/blog-component';
import { PostComponent } from './features/post-component/post-component';

export const routes: Routes = [
  {
    path: ':lang',
    canActivate: [LanguageGuard],
    children: [
      { path: '', component: HomeComponent },
      { path: 'cart', component: CartComponent },
      { path: 'cart/:productId', component: CartComponent },
      { path: 'checkout/:paymentId', component: CheckoutComponent },
      { path: 'welcome', component: Welcome },
      { path: 'pricing', component: TierFeaturesComponent },
      { path: 'services', component: Banner2Component },
      { path: 'faq', component: FAQComponent },
      { path: 'terms', component: TermsComponent },
      { path: 'privacy', component: PrivacyComponent },
      { path: 'payment-policy', component: PaymentPolicyComponent },
      { path: 'support', component: Support },
      { path: 'ConfirmMailCallback', component: ConfirmMailCallback },
      { path: 'blogs', component: BlogComponent },
      { path: 'blogs/:keyword', component: BlogComponent },
      { path: 'post/:slug', component: PostComponent },
      { path: 'payment/:orderId', component: PaymentComponent },


    ]
  },
  { path: '', redirectTo: `/${environment.defaultLang}`, pathMatch: 'full' },
  { path: '**', component: NotFoundComponent }
  ,
];

